import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import clsx from 'clsx';
import MuiButton from '@material-ui/core/Button';
import Button from './Button/Button';
import React from "react";


import { useStyles as useLoginDialogStyles } from '../components/purchase/LoginDialog/LoginDialog'

interface ButtonInfo {
    text: string;
    onClick: () => void | React.Dispatch<React.SetStateAction<any>> | Promise<any>;
    variant?: 'mui' | 'green';
    loading?: boolean;
}

interface PopupProps {
    open: boolean;
    text: string | JSX.Element;
    imgSrc?: string;
    buttons: ButtonInfo[];
    children?: React.ReactNode;
}

const Popup: React.FC<PopupProps> = ({ open, text, imgSrc, buttons, children }) => {

    const classes = useLoginDialogStyles()

    return <>
        <Dialog open={open} maxWidth="sm" fullWidth transitionDuration={0}>
            <DialogContent className={classes.content}>
                <img className={classes.image} src={imgSrc ?? '/lulav-icons/purim-icon.svg'} />

                <div className={clsx(classes.text)}>{text}</div>

                {children}
                <div className={classes.actions}>
                    {buttons.map((buttonInfo: ButtonInfo, i: number) => <span key={i}>
                        {buttonInfo.variant === 'mui' ? <MuiButton
                            onClick={buttonInfo.onClick}
                            color="primary"
                            variant="text"
                            classes={{ label: classes.buttonFont }}
                        >
                            {buttonInfo.text}
                        </MuiButton>
                            : <Button
                                onClick={buttonInfo.onClick}
                                classes={{ root: classes.verify, label: classes.buttonFont }}
                                loading={buttonInfo.loading}
                            >
                                {buttonInfo.text}
                            </Button>}
                    </span>)}
                </div>

            </DialogContent>
        </Dialog>
    </>
}

export default Popup;